export const VOCABULARY_SCORING_RULE_VERSION = 3;
export const VOCABULARY_LIMIT_MS = 30 * 60 * 1000;
let handoff = null;

// Router state survives reload; an in-process handoff deliberately does not.
export function stageVocabularySession(session) { handoff = session; return { vocabularySessionId: session.id }; }
export function peekVocabularySession(id) { return handoff?.id === id ? handoff : null; }
export function discardVocabularySession(id) { if (handoff?.id === id) handoff = null; }

function withProgress(session) {
  const value = Object.values(session.cardStates).reduce((sum, card) => sum + card.streak, 0);
  const max = Object.keys(session.cardStates).length * 3;
  return { ...session, batchProgress: { value, max, remaining: max - value, percent: max ? Math.floor(value / max * 100) : 0 } };
}
function nextAppearance(session) {
  const offset = session.order.findIndex((_, offset) => !session.cardStates[session.order[(session.cursor + offset) % session.order.length]].passed);
  if (offset < 0) return withProgress({ ...session, current: null, status: 'ready_to_complete' });
  const cursor = (session.cursor + offset) % session.order.length;
  const cardId = session.order[cursor];
  const card = session.cards.find(item => item.cardId === cardId);
  return withProgress({ ...session, cursor, current: { ...card, id: `${session.id}:${session.attempts.length}`,
    firstEncounter: card.isNew && !session.attempts.some(item => item.cardId === cardId),
    presented: true, revealed: false, presentationPoints: 2 } });
}
export function beginVocabularyLearning(snapshot, random = Math.random) {
  if (snapshot.phase === 'learning') return snapshot;
  const cards = snapshot.preview?.cards || snapshot.cards || [];
  if (snapshot.scoringRuleVersion !== VOCABULARY_SCORING_RULE_VERSION || !cards.length) throw new Error('Invalid vocabulary batch');
  const order = cards.map(card => card.cardId);
  for (let index = order.length - 1; index > 0; index -= 1) {
    const other = Math.floor(random() * (index + 1));
    [order[index], order[other]] = [order[other], order[index]];
  }
  const cardStates = Object.fromEntries(order.map(cardId => [cardId, { streak: 0, revealed: false, passed: false }]));
  return nextAppearance({ ...snapshot, phase: 'learning', cards, preview: null, status: 'active', order,
    batch: { ...snapshot.batch, cardIds: order }, cardStates, attempts: [], history: [], cursor: 0 });
}
export function revealVocabularyAnswer(session, appearanceId) {
  if (session.status !== 'active' || session.current?.id !== appearanceId) return session;
  const cardId = session.current.cardId;
  return withProgress({ ...session, current: { ...session.current, revealed: true }, cardStates: {
    ...session.cardStates, [cardId]: { ...session.cardStates[cardId], streak: 0, revealed: true },
  } });
}
export function advanceVocabularyCard(session, appearanceId) {
  if (session.status !== 'active' || session.current?.id !== appearanceId) return session;
  const { cardId, revealed } = session.current;
  const previous = session.cardStates[cardId];
  const streak = revealed ? 0 : previous.streak + 1;
  return nextAppearance({ ...session, cursor: (session.cursor + 1) % session.order.length,
    attempts: [...session.attempts, { cardId, revealed }], history: [...session.history, session.current],
    cardStates: { ...session.cardStates, [cardId]: { streak, revealed: previous.revealed || revealed, passed: streak === 3 } },
  });
}
